import { Icon } from '@ur-solutions/react-components'
import { CheckmarkDiv } from '@/modules/activities/components/overview/CheckmarkDiv'
import { cn } from '@/lib/utils'

interface Props {
  label: string
  approved: boolean
  comment: string
  approverName?: string | null
  locked: boolean
  lockText: string
  onToggle: () => void
}

export const ApprovalColumn: React.FC<Props> = ({
  label,
  approved,
  comment,
  approverName,
  locked,
  lockText,
  onToggle,
}) => {
  const handleClick = locked ? undefined : onToggle
  const handleCheckmark = locked
    ? undefined
    : (evt: React.MouseEvent) => {
        evt.preventDefault()
        evt.stopPropagation()
        onToggle()
      }

  return (
    <div
      className={cn(
        'flex w-1/2 max-w-[50%] flex-col gap-2 rounded-xl border p-3',
        approved
          ? 'border-green-200 bg-green-100'
          : comment
          ? 'border-red-200 bg-red-100'
          : 'border-gray-200 bg-white',
        locked && 'opacity-50'
      )}
    >
      <div
        className={cn(
          'flex items-center justify-between gap-2',
          locked
            ? 'cursor-not-allowed [&_*]:pointer-events-none [&_*]:cursor-not-allowed'
            : 'cursor-pointer'
        )}
        onClick={handleClick}
      >
        <span className="font-medium">{label}</span>
        <CheckmarkDiv checked={approved} onClick={handleCheckmark} />
      </div>
      {approved && approverName && (
        <div className="px-1 text-xs text-gray-600">{approverName}</div>
      )}
      {locked && (
        <div className="flex items-center gap-1 text-sm italic text-gray-500">
          <Icon icon="lock" />
          {lockText}
        </div>
      )}
      {comment && (
        <>
          <div className="h-px w-full bg-gray-200" />
          <p className="m-0 whitespace-pre-wrap break-words text-sm">{comment}</p>
        </>
      )}
    </div>
  )
}
